<template>
  <div class="new-products">
    <div class="products-container">
      <div class="title-section">
        <h2 class="section-title">新品推荐</h2>
        <div class="description-slider" v-if="productList.length && currentDescription">
          <div class="description-content">
            {{ currentDescription }}
          </div>
        </div>
        <router-link 
          :to="{
            path: '/feature-zone',
            query: { advertCode: 'HOME_MORENEWPRODUCT' }
          }"
          class="more-link"
        >
          more >
        </router-link>
      </div>
      <div class="products-grid">
        <div 
          v-for="product in productList" 
          :key="product.ProductNo"
          class="product-item"
          @click="handleProductClick(product.Url)"
        >
          <img 
            :src="getImageUrl(product.ImageUrl)" 
            :alt="product.Title"
            class="product-image"
          />
          <div class="price-info">
            <div class="current-price">
              <span class="currency">￥</span>{{ product.Param1 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewProducts } from '@/api/advertisement'
import { AdvertCodes } from '@/api/constants/advertCodes'

export default {
  name: 'NewProducts',
  data() {
    return {
      productList: [],
      currentIndex: 0,
      timer: null
    }
  },
  computed: {
    currentDescription() {
      if (!this.productList.length) return ''
      const desc = this.productList[this.currentIndex].Describe
      if (!desc) return ''
      return desc.length > 15 ? desc.slice(0, 15) + '...' : desc
    }
  },
  created() {
    this.fetchNewProducts()
  },
  mounted() {
    this.startDescriptionSlider()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    async fetchNewProducts() {
      try {
        const res = await getNewProducts()
        if (res.ErrorCode === 0) {
          this.productList = res.Data
        } else {
          console.error('获取新品列表失败:', res.ErrorMessage)
        }
      } catch (error) {
        console.error('获取新品列表失败:', error)
      }
    },
    getImageUrl(imageUrlString) {
      try {
        const imageData = JSON.parse(imageUrlString)[0]
        return imageData.ServerUrl + imageData.FilePath
      } catch (error) {
        console.error('解析图片URL失败:', error)
        return ''
      }
    },
    handleProductClick(url) {
      if (url) {
        window.location.href = url
      }
    },
    startDescriptionSlider() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.productList.length
      }, 3000) // 每3秒切换一次
    }
  }
}
</script>

<style scoped>
.new-products {
  width: calc(100% - 16px);
  background: #fff;
  padding: 12px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin: 8px auto;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.new-products::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 80%;
  height: 40px;
  background: linear-gradient(
    135deg,
    rgba(255, 99, 99, 0.2) 0%,
    rgba(255, 255, 255, 0.4) 30%,
    rgba(255, 255, 255, 0.8) 60%,
    rgba(255, 255, 255, 1) 80%,
    rgba(255, 255, 255, 1) 100%
  );
  z-index: 0;
}

.title-section {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 8px;
  margin-bottom: 12px;
  z-index: 1;
  height: 40px;
  width: 100%;
  box-sizing: border-box;
}

.section-title {
  margin-bottom: 0;
  padding: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.description-slider {
  flex: 1;
  min-width: 0;
}

.description-content {
  padding: 4px 12px;
  font-size: 12px;
  color: #fff;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
  border-radius: 15px;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  width: 100%;
  padding: 0 8px;
  box-sizing: border-box;
}

.product-item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s ease;
  width: 100%;
}

.product-item:hover {
  transform: translateY(-2px);
}

.product-image {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease;
}

.product-item:hover .product-image {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.price-info {
  width: 100%;
  text-align: center;
  margin-top: 6px;
}

.current-price {
  color: #ff4d4f;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.2;
}

.currency {
  font-size: 11px;
  margin-right: 1px;
}

/* 响应式布局 */
@media screen and (min-width: 768px) {
  .new-products {
    width: calc(100% - 24px);
  }
  
  .products-grid {
    gap: 16px;
  }
}

@media screen and (min-width: 1024px) {
  .new-products {
    width: calc(100% - 32px);
  }
}

/* 窄屏适配 */
@media screen and (max-width: 320px) {
  .new-products {
    width: calc(100% - 12px);
  }
  
  .products-grid {
    gap: 8px;
  }
  
  .title-section {
    gap: 8px;
  }
  
  .description-content {
    font-size: 11px;
    padding: 3px 10px;
  }
}

.more-link {
  color: #ff4d4f;
  font-size: 14px;
  text-decoration: none;
  padding: 0 8px;
  flex-shrink: 0;
  white-space: nowrap;
  margin-left: auto;
}
</style> 